import Cookies from "js-cookie";

export default {
    getClientId() {
        try {
            const tracker = window.ga.getAll()[0];
            return tracker.get("clientId");
        } catch (e) {
            return "";
        }
    },

    getSessionId() {
        try {
            const sessionIdCookie = Cookies.get(`_ga_${process.env.REACT_APP_GA4_MEASUREMENT_ID.split("-")[1]}`);
            return sessionIdCookie.split(".")[2];
        } catch (e) {
            return "";
        }
    },

    getEventTimestamp() {
        try {
            const currentTime = Date.now();
            // Timestamp needs to be passed in microseconds
            const currentTimeInMicroseconds = currentTime * 1000;
            // We add up 5 milliseconds to be sure the Page view event has been triggered
            return currentTimeInMicroseconds + 5000;
        } catch (e) {
            return "";
        }
    },

    getFacebookFbp() {
        try {
            return Cookies.get("_fbp") || "";
        } catch (e) {
            return "";
        }
    },

    getFacebookFbc() {
        try {
            return Cookies.get("_fbc") || "";
        } catch (e) {
            return "";
        }
    },

    getFacebookClientUserAgent() {
        try {
            return navigator.userAgent;
        } catch (e) {
            return "";
        }
    },

    getConsentMarketing() {
        try {
            return window.CookieInformation.getConsentGivenFor("cookie_cat_marketing") || false;
        } catch (error) {
            return false;
        }
    },

    getConsentStatistic() {
        try {
            return window.CookieInformation.getConsentGivenFor("cookie_cat_statistic") || false;
        } catch (error) {
            return false;
        }
    },

    getUniqueId() {
        try {
            const uint32 = crypto.getRandomValues(new Uint32Array(1))[0];
            return uint32.toString(16);
        } catch (e) {
            return "";
        }
    },
};
